// Roughly based on FitVid.js by https://github.com/davatron5000/FitVids.js

// The downside is that Content Layout Shift can occur.
// Better to use HTML around <iframe> elements. "<div class="embed-responsive embed-responsive-16by9">" and "</div>" after.

// Instructions: embed a video in RichText or IFrame elements.
// Make sure the embed code contains width and height properties that match the aspect ratio of the video.
// If width 100% then 16:9 ratio will be used. // width 100% not supported by HTML spec !!
// This code will look for all instances of this class and fit the video based on the iFrames Width and Height properties.

import Component from './Component';

export default class FitVid extends Component {

  load() {
    // console.log('favourites.');
    // this.initFitTheVids(); // Remove until FitVid can be improved or replaced with alternative approach.
    super.load();
  }


  initFitTheVids() {

    // List of Video Vendors embeds you want to support
    const sections = ['.richtext-section', '.iframe-element'];
    const players = ['iframe[src*="youtube.com"]', 'iframe[src*="vimeo.com"]', 'iframe[src*="youtu.be"]'];
    const sectionPlayers = [];
    // create selector strings for each video type and sections
    for (let i = 0; i < sections.length; i++) {
      players.map(i => `${sections[i]} ${i}`);
      sectionPlayers.push(players)
    }
    // console.log('players: ', players);

    // Select videos
    const vids = document.querySelectorAll(players.join(","));
    // console.log('vids: ', vids);

    // If there are videos on the page...
    if (vids.length) {
      // Loop through videos
      for (let i = 0; i < vids.length; i++) {
        // Get Video Information
        const fitVid = vids[i];
        let width = fitVid.getAttribute("width") ?? '100%'; // get width else use 100%.
        const height = fitVid.getAttribute("height") ?? '315'; // else youtube default of 315
        console.log('width:', width);

        if (width.includes('%')) {
          // assume 16:9 ratio
          width = height / 9 * 16;
        }

        console.log('width change: ', width);

        const aspectRatio = `${width} / ${height}`;
        //  const parentDiv = fitVid.parentNode;

        // modify iframe properties
        // fitVid.setAttribute("class", 'fitvid');
        fitVid.classList.add('fitvid');
        fitVid.setAttribute("width", width); // overwrite width 100% with an appropriate 16:9 width.
        fitVid.setAttribute("height", height);
        fitVid.setAttribute("aspectRatio", aspectRatio);
        fitVid.style.aspectRatio = aspectRatio;

      }
    }
  }


}

